import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.feedbackDialog,
      callback: function ($$v) {
        _vm.feedbackDialog = $$v;
      },
      expression: "feedbackDialog"
    }
  }, [_c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VForm, {
    ref: "form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.createFormData.apply(null, arguments);
      }
    },
    model: {
      value: _vm.formValid,
      callback: function ($$v) {
        _vm.formValid = $$v;
      },
      expression: "formValid"
    }
  }, [_c('core-n20Card', {
    attrs: {
      "form": _vm.$refs.form,
      "buttons": _vm.buttons
    },
    on: {
      "close": _vm.close
    }
  }, [_c(VCardTitle, {
    staticClass: "px-1"
  }, [_c('h3', {
    class: `my-0 headline ${_vm.color}--text`
  }, [_vm._v("\n            " + _vm._s(_vm.dialogTitle) + "\n          ")])]), _vm.type === 'dontLike' && !_vm.isLoading ? _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VRadioGroup, {
    attrs: {
      "row": ""
    },
    model: {
      value: _vm.bug,
      callback: function ($$v) {
        _vm.bug = $$v;
      },
      expression: "bug"
    }
  }, [_c(VRadio, {
    attrs: {
      "label": _vm.$i18n_t('Common.help.bug'),
      "color": _vm.color,
      "value": "1",
      "hide-details": ""
    }
  }), _c(VRadio, {
    attrs: {
      "label": _vm.$i18n_t('Common.help.dontLikeSomething'),
      "color": _vm.color,
      "value": "0",
      "hide-details": ""
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.type === 'dontLike' && _vm.isLoading ? _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VSkeletonLoader, {
    attrs: {
      "type": "article"
    }
  })], 1)], 1) : _vm._e(), _vm.type !== 'like' && !_vm.isLoading ? _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('Common.help.titel'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hint": this.$i18n_t('Common.help.maxLength'),
      "counter": "",
      "maxlength": "50",
      "hide-details": "auto",
      "autocomplete": "off"
    },
    model: {
      value: _vm.formItem.title,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "title", $$v);
      },
      expression: "formItem.title"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VTextarea, {
    attrs: {
      "label": _vm.$i18n_t('Common.description'),
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.description,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "description", $$v);
      },
      expression: "formItem.description"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VTextarea, {
    attrs: {
      "label": _vm.feedback,
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "placeholder": _vm.placeholder,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.feedback,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "feedback", $$v);
      },
      expression: "formItem.feedback"
    }
  })], 1)], 1) : _vm._e(), _vm.type !== 'like' && _vm.isLoading ? _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VSkeletonLoader, {
    attrs: {
      "type": "text@4"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VSkeletonLoader, {
    attrs: {
      "type": "text@4"
    }
  })], 1)], 1) : _vm._e(), _vm.type === 'like' && !_vm.isLoading ? _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VTextarea, {
    attrs: {
      "label": _vm.$i18n_t('Common.description'),
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.description,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "description", $$v);
      },
      expression: "formItem.description"
    }
  })], 1)], 1) : _vm._e(), _vm.type === 'like' && _vm.isLoading ? _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VSkeletonLoader, {
    attrs: {
      "type": "text@4"
    }
  })], 1)], 1) : _vm._e(), _c('media-upload-multiple', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isLoading,
      expression: "!isLoading"
    }],
    ref: "uploadMultiple",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "upload-files": _vm.files,
      "clear-files": _vm.clearFiles
    }
  }), _vm.isLoading ? _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VSkeletonLoader, {
    attrs: {
      "type": "list-item-avatar"
    }
  }), _c(VSkeletonLoader, {
    staticClass: "ml-8",
    attrs: {
      "type": "list-item-two-line"
    }
  })], 1)], 1) : _vm._e(), !_vm.isLoading ? _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VCheckbox, {
    staticClass: "shrink mx-0 my-0",
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.help.contactMe'),
      "hide-details": ""
    },
    model: {
      value: _vm.formItem.contact,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "contact", $$v);
      },
      expression: "formItem.contact"
    }
  })], 1), _vm.formItem.contact ? _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "autocomplete": "off"
    },
    model: {
      value: _vm.formItem.email,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "email", $$v);
      },
      expression: "formItem.email"
    }
  })], 1) : _vm._e(), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_vm.type === 'like' ? _c('p', [_vm._v(_vm._s(_vm.$i18n_t('Common.help.sendHint')))]) : _c('p', [_vm._v(_vm._s(_vm.$i18n_t('Common.help.sendHint2')))])]), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('Common.help.userId')) + ": " + _vm._s(_vm.formItem.userId))]), _c('p', [_vm._v(_vm._s(_vm.$i18n_t('Common.help.systemVersion')) + ": " + _vm._s(_vm.version))])])], 1) : _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VSkeletonLoader, {
    attrs: {
      "type": "article"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VSkeletonLoader, {
    attrs: {
      "type": "sentences: text@2"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };